import {
  Accordion,
  AccordionItem,
  Badge,
  Button,
  Card,
  CardBody,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Code,
  Separator,
} from "@one-nexty/components-web";

import { Preview } from "../ui/preview";
import { Section, SubSection } from "../ui/section";

export function LayoutSection() {
  return (
    <Section
      id="structure"
      eyebrow="Structure"
      title="Card, Separator & Accordion"
      description="Card est composé, pas configuré : Header, Body et Footer s'assemblent au lieu d'empiler des props. L'accordéon repose sur <details> natif — Ctrl+F ouvre la bonne section."
    >
      <SubSection title="Cards" hint="interactive : l'ombre de survol est un fondu d'opacité, pas une ombre interpolée">
        <Preview
          layout="stack"
          label="card.tsx"
          code={`<Card>
  <CardHeader>
    <CardTitle>Plan Équipe</CardTitle>
    <CardDescription>Facturation mensuelle.</CardDescription>
  </CardHeader>
  <CardBody>…</CardBody>
  <CardFooter>
    <Button fullWidth>Choisir ce plan</Button>
  </CardFooter>
</Card>

<Card variant="raised" interactive tabIndex={0}>…</Card>
<Card variant="sunken">…</Card>`}
        >
          <div className="grid gap-5 lg:grid-cols-3">
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between gap-3">
                <CardTitle>Plan Équipe</CardTitle>
                <Badge tone="success" dot>
                  Actif
                </Badge>
              </div>
              <CardDescription>Facturation mensuelle, résiliable à tout moment.</CardDescription>
            </CardHeader>
            <CardBody>
              <p className="text-3xl font-semibold tracking-tight text-fg tabular-nums">
                24&nbsp;€
                <span className="text-sm font-normal text-fg-muted"> / utilisateur / mois</span>
              </p>
              <ul className="mt-4 space-y-1.5 text-sm text-fg-muted">
                <li>Utilisateurs illimités</li>
                <li>Support prioritaire</li>
                <li>SSO &amp; journal d'audit</li>
              </ul>
            </CardBody>
            <CardFooter>
              <Button fullWidth>Choisir ce plan</Button>
            </CardFooter>
          </Card>

          <Card variant="raised" interactive tabIndex={0}>
            <CardBody>
              <p className="text-xs font-medium tracking-wide text-fg-muted uppercase">
                interactive
              </p>
              <p className="mt-2 text-sm text-fg-muted">
                Survolez : la carte se soulève d'un pixel et son ombre se révèle. Un pixel suffit à
                faire lire un décollement.
              </p>
            </CardBody>
          </Card>

          <Card variant="sunken">
            <CardBody>
              <p className="text-xs font-medium tracking-wide text-fg-muted uppercase">
                variant=&quot;sunken&quot;
              </p>
              <p className="mt-2 text-sm text-fg-muted">
                Fond en retrait, sans relief. Pour un encadré secondaire.
              </p>
            </CardBody>
          </Card>
          </div>
        </Preview>
      </SubSection>

      <SubSection title="Séparateurs">
        <Preview
          layout="stack"
          label="separator.tsx"
          code={`<Separator />
<Separator label="ou" />
<Separator orientation="vertical" />`}
        >
          <Separator />
          <Separator label="ou" />
          <div className="flex h-10 items-center gap-4">
            <span className="text-sm text-fg-muted">Gauche</span>
            <Separator orientation="vertical" />
            <span className="text-sm text-fg-muted">Droite</span>
          </div>
        </Preview>
      </SubSection>

      <SubSection title="Accordéon" hint="name partagé : les sections s'excluent mutuellement">
        <Preview
          layout="stack"
          label="accordion.tsx"
          code={`<Accordion>
  <AccordionItem name="faq" title="Pourquoi OKLCH ?" open>…</AccordionItem>
  <AccordionItem name="faq" title="Pourquoi pas de build ?">…</AccordionItem>
</Accordion>`}
        >
          <Accordion>
          <AccordionItem name="faq" title="Pourquoi OKLCH plutôt que hexadécimal ?" open>
            OKLCH est perceptuellement uniforme : à luminosité égale, deux teintes paraissent aussi
            claires l'une que l'autre. Une échelle 50→950 y progresse régulièrement, ce qu'une
            palette hexadécimale ne garantit pas.
          </AccordionItem>
          <AccordionItem name="faq" title="Pourquoi pas de build pour les composants ?">
            Le package expose son TypeScript source : aucune étape de build à attendre, une seule
            source de vérité pour les types, et le bundler de l'application fait le travail.
          </AccordionItem>
          <AccordionItem name="faq" title="Comment ajouter React Native ?">
            En ajoutant un formatter dans <Code>packages/tokens/build.mjs</Code>. La conversion
            OKLCH → hexadécimal et rem → px existe déjà : <Code>@one-nexty/tokens/native</Code> exporte
            un jeu clair et un jeu sombre prêts pour StyleSheet.create().
            </AccordionItem>
          </Accordion>
        </Preview>
      </SubSection>
    </Section>
  );
}
